
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/medicalsoftwarequotes/contact-us",
      function () {
        return require("private-next-pages/medicalsoftwarequotes/contact-us.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/medicalsoftwarequotes/contact-us"])
      });
    }
  